module.exports = __webpack_public_path__ + "img/log-out.27441c2c.svg";